import * as React from "react";
import { makeStyles } from "@material-ui/styles";
import { getImageUrl } from "../../utils/images";
import FallBackImage from "../FallBackImage";
import ArrowsCarousel from "../ArrowsCarousel";
import { useEnvContext } from "../../env";
const useStyles = makeStyles(({
  breakpoints,
  typography
}) => ({
  img: {
    [breakpoints.down("xs")]: {
      maxHeight: typography.pxToRem(153),
      maxWidth: typography.pxToRem(153),
      width: typography.pxToRem(153)
    },
    [breakpoints.up("sm")]: {
      maxHeight: typography.pxToRem(140),
      maxWidth: typography.pxToRem(140),
      width: typography.pxToRem(140)
    }
  }
}));

const DeliveryImagesCarousel = ({
  images = [],
  showFullImage,
  withoutArrows,
  entityCode
}) => {
  const styles = useStyles();
  const {
    API_HOST,
    ENTITY_PREFIX
  } = useEnvContext();
  const slides = images.map(image => {
    const src = getImageUrl(API_HOST, ENTITY_PREFIX, entityCode, image.key, {
      imageType: image.type
    });
    return /*#__PURE__*/React.createElement(FallBackImage, {
      key: image.key + image.type,
      className: styles.img,
      onClick: () => showFullImage(src),
      src: src,
      alt: ""
    });
  });
  const [carouselIndex, setCarouselIndex] = React.useState(0);
  const responsiveCarouselMap = {
    "0": {
      items: 1
    }
  };
  return /*#__PURE__*/React.createElement(ArrowsCarousel, {
    mouseTrackingEnabled: true,
    touchTrackingEnabled: true,
    dotsDisabled: true,
    buttonsDisabled: true,
    infinite: false,
    items: slides,
    responsive: responsiveCarouselMap,
    withoutArrows: withoutArrows,
    slideIndex: carouselIndex,
    onSlideIndexChange: setCarouselIndex
  });
};

export default DeliveryImagesCarousel;